/**
 * WCWN About Page — Scroll Reveal
 * Lightweight IntersectionObserver for [data-about-reveal] and [data-about-reveal-stagger].
 * Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (window.WCWYAboutRevealBound) return;
  window.WCWYAboutRevealBound = true;

  var targets = Array.prototype.slice.call(
    document.querySelectorAll('[data-about-reveal], [data-about-reveal-stagger]')
  );

  function showAll() {
    targets.forEach(function (element) {
      element.classList.add('is-visible');
    });
  }

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    !('IntersectionObserver' in window)
  ) {
    showAll();
    return;
  }

  document.documentElement.classList.add('wcwy-about-motion-ready');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  });

  targets.forEach(function (element) {
    observer.observe(element);
  });

  window.setTimeout(showAll, 1600);
})();
